import router from './router'

const whitelist = ['/login'] //白名单路由，不需要登录也能进入的页面
//对路由进行拦截
//before的意思是在跳转到目标路由之前拦截
//参数解释
//  to - 目标路由
//  from  - 来源路由
//  next  - 是一个函数，可以指定跳转到哪个路由，如果不指定，就跳转到to这个路由
router.beforeEach(async(to, from, next) => {
    console.log('to-----------------', to );
    console.log('from -------------- ', from)
    let token = localStorage.getItem('login-token');
    if(token){//如果token存在，表示登录成功过
        if('/login' == to.path){//现在是登录状态，用户访问登录页面不需要再登录，可以直接转到首页
            next('/');
        }else{
            next();//放行
        }
    }else{ //如果token不存在，表示没登录或者登录没成功过
        //虽然没有登录，但是你的目标路由在白名单里，所以直接放行
        if(whitelist.indexOf(to.path) != -1){
            next();//放行
        }else{ //如果不在白名单，不放行，你没有登录不让进，先去登录吧
            next('/login') //没有登录，跳到登录页面
        }
    }
});